import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertOctagon, Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';
import { getToken } from '../../services/tokenService';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (v) => `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €`;
const fr = (d) => (d ? d.slice(0, 10).split('-').reverse().join('/') : '—');

/** Factures & Reçus ESS : dossiers dont une échéance est dépassée, reste dû et relance e-mail + SMS. */
export default function TableauImpayes() {
  const [data, setData] = useState(null);
  const [envoi, setEnvoi] = useState(null);
  const headers = () => ({ Authorization: `Bearer ${getToken()}` });
  const charger = () => axios.get(`${API}/solde-du/admin/impayes`, { headers: headers() })
    .then((r) => setData(r.data)).catch(() => setData({ items: [], total: 0, reste_total: 0 }));
  useEffect(() => { charger(); }, []);
  const relancer = async (x) => {
    if (!window.confirm(`Envoyer au membre une relance de ${eur(x.reste)} par e-mail et SMS, avec le lien de paiement carte ?`)) return;
    setEnvoi(x.souscription_id);
    try {
      const { data: r } = await axios.post(`${API}/solde-du/admin/impayes/${x.souscription_id}/relancer`, {}, { headers: headers() });
      toast.success(`Relance envoyée — e-mail ${r.relance.email ? 'envoyé' : 'non envoyé'}, SMS ${r.relance.sms ? 'envoyé' : 'non envoyé'}`);
      charger();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Relance impossible');
    } finally {
      setEnvoi(null);
    }
  };
  if (!data) return <div className="p-8 text-center text-gray-500"><Loader2 className="h-5 w-5 animate-spin inline" /></div>;
  return (
    <div className="bg-white rounded-xl border shadow-sm p-5 space-y-4" data-testid="tableau-impayes">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-gray-900 flex items-center gap-2"><AlertOctagon className="h-5 w-5 text-rose-600" />Échéances dépassées</h3>
        <div className="text-sm text-gray-600" data-testid="impayes-total">{data.total} dossier(s) — reste dû total <b className="text-rose-700">{eur(data.reste_total)}</b></div>
      </div>
      {data.items.length === 0 ? (
        <p className="text-sm text-gray-500 py-6 text-center" data-testid="impayes-vide">Aucune échéance dépassée.</p>
      ) : (
        <table className="w-full text-sm">
          <thead><tr className="text-left text-gray-500 border-b">
            <th className="py-2">Dossier</th><th>Échéance dépassée</th><th className="text-right">Payé</th><th className="text-right pr-6">Reste dû</th><th className="pl-2">Relances</th><th />
          </tr></thead>
          <tbody>
            {data.items.map((x) => (
              <tr key={x.souscription_id} className="border-b last:border-0" data-testid={`impaye-row-${x.souscription_id}`}>
                <td className="py-2"><div className="font-medium">{x.raison_sociale || '—'}</div><div className="text-xs text-gray-500 font-mono">{x.reference}</div></td>
                <td className="text-rose-700 font-medium">{fr(x.echeance_depassee)}</td>
                <td className="text-right">{eur(x.paye)}</td>
                <td className="text-right pr-6 font-semibold text-rose-700">{eur(x.reste)}</td>
                <td className="pl-2 text-xs text-gray-600">{x.nb_relances}{x.derniere_relance ? ` (dernière ${fr(x.derniere_relance)})` : ''}</td>
                <td className="text-right">
                  <button onClick={() => relancer(x)} disabled={envoi === x.souscription_id} data-testid={`impaye-relancer-${x.souscription_id}`}
                    className="inline-flex items-center gap-1.5 rounded-lg bg-rose-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-rose-700 disabled:opacity-50">
                    {envoi === x.souscription_id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />}Relancer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
